import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionsDisplayGridRowDataFragmentGql } from './VirtualConnectionsDisplayGridRowDataFragmentGql';

export const DatabaseDownstreamVirtualConnectionsQueryGql: DocumentNode = gql`
query DatabaseDownstreamVirtualConnectionsQuery(
  $databaseId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!,
) {
  databases(filter: { id: $databaseId }) {
    downstreamVirtualConnectionsConnection(
      first: $first,
      offset: $offset,
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowDataFragment
      }
    }
    maxDownstreamDatasources: downstreamVirtualConnectionsConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: downstreamVirtualConnectionsConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${VirtualConnectionsDisplayGridRowDataFragmentGql}
`;
